import type { JSX } from "react";
import type { ReactNode } from "react";
// Thin wrapper over the shadcn Dialog, preserving the {open,onClose,title}
// API every page already calls. Focus-trap, Esc-to-close, scroll-lock and the
// ✕ button come from Radix Dialog for free.

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog.js";

export function Modal({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
